import { Injectable } from "@angular/core";
import { Topics } from "@common/interfaces/topics";
import { IID_OL_RISPOSTA_SOLLECITO } from "@common/interfaces/interfaceData";
import { ID } from '@common/interfaces/id';
import { EntityState, EntityStore, StoreConfig } from "@datorama/akita";

export interface IIdOlRispostaSollecitoState extends EntityState<IID_OL_RISPOSTA_SOLLECITO, ID> { }

@Injectable({
  providedIn: 'root'
})
@StoreConfig({ name: Topics.IID_OL_RISPOSTA_SOLLECITO })
export class IIDolRispostaSollecitoStore extends EntityStore<IIdOlRispostaSollecitoState> {
  constructor() {
    super([]);
  }
}
